import { useState } from "react";
import { useSelector } from "react-redux";
import ManageVirtualEvents from "./ManageVirtualEvents";
import MenteeHeader from "../../components/MenteeHeader";
import TransactionsList from "../Profile/Transactions";
import useDashboardActiveTab from "../../hooks/useDashboardActiveTab";

export default function SponsorDashboard() {
  const role = useSelector((state) => state.auth?.loginDetails?.profile?.role);
  const [searchTerm, setSearchTerm] = useState("");
  const activeTab = useDashboardActiveTab("managecontent");

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <>
      {activeTab !== "transactions" && (
        <MenteeHeader
          role={role?.join(", ")}
          active={activeTab}
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
        />
      )}
      {activeTab === "managecontent" && (
        <ManageVirtualEvents searchTerm={searchTerm} />
      )}
      {activeTab === "transactions" && (
        <TransactionsList searchTerm={searchTerm} />
      )}
    </>
  );
}
